import { render, staticRenderFns } from "./SpecifyLocation.vue?vue&type=template&id=1a8c2345&lang=pug&"
import script from "./SpecifyLocation.vue?vue&type=script&lang=js&"
export * from "./SpecifyLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports